


















































































import PendingSensitivities from "@/components/filters-bar/PendingSensitivities.vue";
import { FiltersConfig, UseFilters } from "./filters.state";
import Vue from "vue";
import PendingSeverities from "@/components/filters-bar/PendingSeverities.vue";
import PendingSources from "@/components/filters-bar/PendingSources.vue";
import InfoTypes from "@/components/filters-bar/InfoTypes.vue";
import { TimeAxisRangeInput } from "@/gql/types";
import DropDownSimple from "../dropdown/DropDownSimple.vue";
import { computed, onMounted } from "@vue/composition-api";
import InfoTypesByVirtual from "../filters-bar/InfoTypesByVirtual.vue";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    PendingSensitivities,
    PendingSeverities,
    PendingSources,
    InfoTypes,
    DropDownSimple,
    InfoTypesByVirtual,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    z: {
      type: Object,
      required: true,
    },
    exclude_folder_labels_in_info_types: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const filters = UseFilters(props.config as FiltersConfig);
    const [insights, selected_insight, set_selected_insight] = filters.insights;
    const [
      context_labels,
      selected_context_label,
      set_selected_context_label,
    ] = filters.context_labels;

    const apply_sensitivities = () => {
      filters.sensitivities.submit();
      update_host();
    };

    const apply_severities = () => {
      filters.severities.submit();
      update_host();
    };

    const apply_sources = () => {
      filters.sources.submit();
      update_host();
    };

    const on_info_types_change = (selected_info_types: string[]) => {
      filters.selected_info_types.value = selected_info_types;
      update_host();
    };

    const on_select_insight = (option: any) => {
      set_selected_insight(option);
      update_host();
    };

    const on_select_context_label = (option: any) => {
      set_selected_context_label(option);
      update_host();
    };

    const update_host = () => {
      emit("on_change", filters.to_cords(props.z as TimeAxisRangeInput));
    };

    const is_main_label_id_virtual = computed(() => {
      const config: any = props.config;
      const id =
        config.info_types.selected.length > 0
          ? config.info_types.selected[0]
          : "";

      if (id) {
        return SharedState.getInfoType(id).labelCategory === "Virtual";
      } else {
        return false;
      }
    });

    onMounted(() => {
      if (
        // @ts-ignore
        props.config.info_types.selected &&
        // @ts-ignore
        props.config.info_types.selected.length > 0
      ) {
        //selected_info_types
        filters.selected_info_types.value = [
          //  @ts-ignore
          props.config.info_types.selected[0],
        ];
      }

      if (
        // @ts-ignore
        props.config.context_labels.selected &&
        // @ts-ignore
        props.config.context_labels.selected.length > 0
      ) {
        // @ts-ignore
        set_selected_context_label(props.config.context_labels.selected[0]);
      }
    });
    /**
     * @public
     * */
    const get_tags = () => {
      return {
        label: filters.selected_info_types.value
          .map((id) => SharedState.getInfoType(id).labelName)
          .join(","),
        severity: filters.severities.selected.value.join(","),
        application: filters.sources.selected.value.join(","),
      };
    };

    return {
      // sensitivity
      sensitivities: filters.sensitivities,
      apply_sensitivities,
      // severities
      severities: filters.severities,
      apply_severities,
      // sources
      sources: filters.sources,
      apply_sources,
      // info types
      on_info_types_change,
      selected_info_types: filters.selected_info_types,
      // current_select_info_types_ids
      context_labels,
      selected_context_label,
      on_select_context_label,
      // insights (share type)
      insights,
      selected_insight,
      on_select_insight,
      is_main_label_id_virtual,
      // public
      get_tags,
    };
  },
});
